import { Button, ManageAccountCard, useViewport } from '@tryhackme/thm-ui-components';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { usePricing } from 'src/common/hooks';
import { BREAKPOINTS } from 'src/common/constants/breakpoints';
import { featureCards, RoadmapTypes } from '../../roadmap.constants';
import { StyledUpgradeToPremiumContainer, StyledInfoBar, StyledTextContainer, StyledFeatureCardContainer, StyledInfoIcon, StyledRightGroup, StyledUpgradeToPremiumTitleContainer } from './upgrade-to-premium.styles';
export const UpgradeToPremium = ({
  selectedRoadmap
}: {
  selectedRoadmap?: string;
}) => {
  const navigate = useNavigate();
  const {
    width
  } = useViewport();
  const isMobile = width < BREAKPOINTS.MOBILE;
  const {
    price,
    symbol
  } = usePricing();
  return <StyledUpgradeToPremiumContainer selectedRoadmap={selectedRoadmap} data-sentry-element="StyledUpgradeToPremiumContainer" data-sentry-component="UpgradeToPremium" data-sentry-source-file="upgrade-to-premium.tsx">
      {selectedRoadmap === RoadmapTypes.PREMIUM_ROADMAP && <StyledInfoBar>
          <StyledInfoIcon icon={faCircleInfo} />
          <span>Subscribe to follow the premium roadmap and enhance your learning experience.</span>
        </StyledInfoBar>}
      <StyledTextContainer data-sentry-element="StyledTextContainer" data-sentry-source-file="upgrade-to-premium.tsx">
        <div>
          <StyledUpgradeToPremiumTitleContainer data-sentry-element="StyledUpgradeToPremiumTitleContainer" data-sentry-source-file="upgrade-to-premium.tsx">
            <h2>Upgrade to</h2>
            <h2>Premium</h2>
          </StyledUpgradeToPremiumTitleContainer>
          <p>Enhance your hacking experience</p>
        </div>
        <StyledRightGroup data-sentry-element="StyledRightGroup" data-sentry-source-file="upgrade-to-premium.tsx">
          <div>
            <h2>
              {symbol}
              {price}/month
            </h2>
          </div>
          <Button onClick={() => {
          navigate('/why-subscribe');
        }} data-sentry-element="Button" data-sentry-source-file="upgrade-to-premium.tsx">
            Subscribe now
          </Button>
        </StyledRightGroup>
      </StyledTextContainer>
      {!isMobile && <StyledFeatureCardContainer>
          {featureCards.map(card => <ManageAccountCard key={card.title.toLowerCase().replace(' ', '-')} {...card} />)}
        </StyledFeatureCardContainer>}
    </StyledUpgradeToPremiumContainer>;
};